// hooks/useAddressOptions.js
import { useQuery } from "@tanstack/react-query";
import apiSetting from "../../services/setting";

export function useAddressOptions({ lang = "th" }) {
  const province = useQuery({
    queryKey: ["address-options", "province", lang],
    queryFn: () => apiSetting.provinceAddressOption({ lang }),
    enabled: !!lang,
    staleTime: 1000 * 60 * 5,
  });

  const district = useQuery({
    queryKey: ["address-options", "district", lang],
    queryFn: () => apiSetting.districtAddressOption({ lang }),
    enabled: !!lang,
    staleTime: 1000 * 60 * 5,
  });

  const subDistrict = useQuery({
    queryKey: ["address-options", "subDistrict", lang],
    queryFn: () => apiSetting.subDistrictAddressOption({ lang }),
    enabled: !!lang,
    staleTime: 1000 * 60 * 5,
  });

  const country = useQuery({
    queryKey: ["address-options", "country", lang],
    queryFn: () => apiSetting.countriesAddress(lang), 
    enabled: !!lang,
    staleTime: 1000 * 60 * 5,
  });

  return { province, district, subDistrict, country };
}